import React from 'react';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
const CMP = (props: Partial<CustomIconComponentProps>) => (
  <svg viewBox="0 0 18 18" width={18} height={18}>
    <g id="帮助中心" transform="translate(-121.624 -119.678)" opacity="0.65" fill="currentColor">
      <path
        id="路径_6284"
        data-name="路径 6284"
        d="M391.436,285.946a.849.849,0,1,0,.848.849A.849.849,0,0,0,391.436,285.946Zm0-9.036a2.819,2.819,0,0,0-2.828,2.8.566.566,0,0,0,1.131,0,1.667,1.667,0,0,1,1.7-1.672,1.706,1.706,0,0,1,1.7,1.71c0,.378-.474.85-.931,1.308a3.44,3.44,0,0,0-1.331,2.257v.957a.566.566,0,1,0,1.131,0v-.956c0-.457.508-.964,1-1.456a3.222,3.222,0,0,0,1.263-2.109A2.838,2.838,0,0,0,391.436,276.91Z"
        transform="translate(-260.663 -153.449)"
        stroke="#000"
        stroke-width="0.3"
      />
      <path
        id="路径_6285"
        data-name="路径 6285"
        d="M135.834,119.828h-10.12a3.974,3.974,0,0,0-3.94,4.017v10.12a3.891,3.891,0,0,0,3.94,3.862h10.12a3.957,3.957,0,0,0,3.94-3.94V123.845A3.974,3.974,0,0,0,135.834,119.828Zm2.781,14.06a2.769,2.769,0,0,1-2.781,2.781h-10.12a2.769,2.769,0,0,1-2.781-2.781V123.845a2.769,2.769,0,0,1,2.781-2.781h10.12a2.769,2.769,0,0,1,2.781,2.781Z"
        stroke="#000"
        stroke-width="0.3"
      />
    </g>
  </svg>
);

export default CMP;
